export default {
  wallet_summary: null,
  shipments: [],
  shipments_pagination: null,
  shipment_detail: null,
  wallet_movements: [],
  wallet_movements_pagination: null,
  error_msg: "",
};
